import { gymSchedules, gymPricing, gymBenefits, gymTrainers, waLink, waMessages } from '../data/content';
import useReveal from '../hooks/useReveal';
import useLazyVideo from '../hooks/useLazyVideo';
import gymVideo from '../assets/gym-video.mp4';
import gymVideo2 from '../assets/gym-video-2.mp4';
import gymVideo3 from '../assets/gym-video-3.mp4';
import gymPoster from '../assets/gym-video-poster.jpg';
import gymPoster2 from '../assets/gym-video-2-poster.jpg';
import gymPoster3 from '../assets/gym-video-3-poster.jpg';
import './Gimnasio.css';

export default function Gimnasio() {
  const gridRef = useReveal();
  const video1Ref = useLazyVideo();
  const video2Ref = useLazyVideo();
  const video3Ref = useLazyVideo();
  const infoRef = useReveal();

  return (
    <section id="gimnasio" className="gimnasio">
      <div className="gimnasio__kanji-bg">力</div>
      <div className="gimnasio__inner">
        <div className="gimnasio__header">
          <div className="gimnasio__eyebrow">
            <span className="gimnasio__rule" />
            <span>Nuestras Instalaciones</span>
          </div>
          <h2 className="gimnasio__title">
            El <span className="text-red"> GIMNASIO KAMAE</span>
          </h2>
          <p className="gimnasio__lead serif">
            Preparación física y entrenamientos dirigidos para niños y
            adolescentes, adaptados a tus necesidades y a tu deporte. Un espacio
            seguro, equipado y con los mejores profesionales.
          </p>
          <div className="gimnasio__tags">
            <span className="gimnasio__tag">Monitoreo de cámaras en tiempo real</span>
            <span className="gimnasio__tag">Alto rendimiento deportivo</span>
          </div>
        </div>

        <div className="gimnasio__content">
          <div ref={gridRef} className="gimnasio__videos reveal">
            <figure className="gimnasio__tile gimnasio__tile--main">
              <video ref={video1Ref} data-src={gymVideo} poster={gymPoster} preload="none" muted loop playsInline />
              <figcaption className="gimnasio__cap">
                <span className="gimnasio__cap-tag">Zona de entrenamiento</span>
              </figcaption>
            </figure>
            <figure className="gimnasio__tile">
              <video ref={video2Ref} data-src={gymVideo2} poster={gymPoster2} preload="none" muted loop playsInline />
              <figcaption className="gimnasio__cap">
                <span className="gimnasio__cap-tag">Equipamiento</span>
              </figcaption>
            </figure>
            <figure className="gimnasio__tile">
              <video ref={video3Ref} data-src={gymVideo3} poster={gymPoster3} preload="none" muted loop playsInline />
              <figcaption className="gimnasio__cap">
                <span className="gimnasio__cap-tag">Vista general del dojo</span>
              </figcaption>
            </figure>
          </div>

          <div ref={infoRef} className="gimnasio__info reveal">
            <div className="gimnasio__schedules">
              <h3 className="gimnasio__section-title">Horarios</h3>
              <div className="gimnasio__schedule-list">
                {gymSchedules.map((s) => (
                  <div key={s.group + s.days} className="gimnasio__schedule-item">
                    <div className="gimnasio__schedule-group">{s.group}</div>
                    <div className="gimnasio__schedule-detail">
                      <span className="gimnasio__schedule-ages">{s.ages}</span>
                      <span className="gimnasio__schedule-days">{s.days}</span>
                      <span className="gimnasio__schedule-hours">{s.hours}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="gimnasio__trainers">
              <h3 className="gimnasio__section-title">Entrenadores</h3>
              <div className="gimnasio__trainer-list">
                {gymTrainers.map((t) => (
                  <div key={t.name} className="gimnasio__trainer-card">
                    <div className="gimnasio__trainer-media">
                      <img
                        className={`gimnasio__trainer-img${t.cutout ? ' gimnasio__trainer-img--cutout' : ''}`}
                        src={t.image}
                        alt={t.name}
                        loading="lazy"
                        style={{ objectPosition: t.objectPosition }}
                      />
                    </div>
                    <div className="gimnasio__trainer-info">
                      <div className="gimnasio__trainer-name">{t.name}</div>
                      <div className="gimnasio__trainer-role">{t.role}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="gimnasio__benefits">
              <h3 className="gimnasio__section-title">Por qué el gym para niños</h3>
              <ul className="gimnasio__benefit-list">
                {gymBenefits.map((b) => (
                  <li key={b} className="gimnasio__benefit">{b}</li>
                ))}
              </ul>
            </div>

            <div className="gimnasio__pricing">
              <h3 className="gimnasio__section-title">Mensualidades</h3>
              <div className="gimnasio__pricing-list">
                {gymPricing.map((p) => (
                  <div key={p.program} className="gimnasio__pricing-card">
                    <div className="gimnasio__pricing-program">{p.program}</div>
                    <div className="gimnasio__pricing-ages">{p.ages}</div>
                    <div className="gimnasio__pricing-amount">
                      <span className="gimnasio__pricing-price">{p.price}</span>
                      <span className="gimnasio__pricing-period">{p.period}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="gimnasio__cta">
              <div className="gimnasio__cta-label">Habla directo con el Sensei</div>
              <div className="gimnasio__cta-actions">
                <a
                  href={waLink(waMessages.karate)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="gimnasio__cta-btn gimnasio__cta-btn--primary"
                >
                  Consultar por Karate Do
                </a>
                <a
                  href={waLink(waMessages.gym)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="gimnasio__cta-btn"
                >
                  Consultar por Preparación Física
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
